import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import { red } from '@material-ui/core/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { booleanIconCell } from '../../utils/cellRenderers';
import { formatDate } from '../../utils/formatters';

/**
 * SentStatusCell
 * Renders the sent status icon, tooltip, and resend/error icons for a notification row.
 * Props:
 *   isSent: boolean
 *   errorMessage: string
 *   latestResendError: string
 *   latestResendDate: string|Date
 *   notificationDateString: string
 */
const SentStatusCell = ({ isSent, errorMessage, latestResendError, latestResendDate, notificationDateString }) => {
    let tooltipTitle;
    if (isSent) {
        tooltipTitle = `${notificationDateString} Sent`;
    } else if (errorMessage) {
        tooltipTitle = `${notificationDateString} Errored: ${errorMessage}`;
    } else {
        tooltipTitle = 'Not sent';
    }
    let resendStatus = null;
    if (latestResendError) {
        resendStatus = (
            <Tooltip title={`${formatDate(latestResendDate)} Re-send error: ${latestResendError}`}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                    <ClearIcon style={{ fill: red[500] }} />
                    <span>{formatDate(latestResendDate)}</span>
                </span>
            </Tooltip>
        );
    } else if (latestResendDate) {
        resendStatus = (
            <Tooltip title={`${formatDate(latestResendDate)} Re-sent`}>
                <CheckCircleIcon style={{ color: '#1976d2' }} />
            </Tooltip>
        );
    }

    return (
        <span style={{ display: 'inline-flex', flexDirection: 'row', alignItems: 'center', gap: 12 }}>
            <Tooltip title={tooltipTitle}>
                {booleanIconCell(isSent)}
            </Tooltip>
            {resendStatus}
        </span>
    );
};

SentStatusCell.propTypes = {
    isSent: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    latestResendError: PropTypes.string,
    latestResendDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
    notificationDateString: PropTypes.string.isRequired
};

export default SentStatusCell;